export const COUNTRIES = {
    'AF': {"label": 'Afghanistan', "EEA": false, "AD": false, "BCR": false},
    'AX': {"label": 'Åland Islands', "EEA": false, "AD": false, "BCR": false},
    'AL': {"label": 'Albania', "EEA": false, "AD": false, "BCR": false},
    'DZ': {"label": 'Algeria', "EEA": false, "AD": false, "BCR": false},
    'AS': {"label": 'American Samoa', "EEA": false, "AD": false, "BCR": false},
    'AD': {"label": 'Andorra', "EEA": false, "AD": true, "BCR": false},
    'AO': {"label": 'Angola', "EEA": false, "AD": false, "BCR": false},
    'AI': {"label": 'Anguilla', "EEA": false, "AD": false, "BCR": false},
    'AQ': {"label": 'Antarctica', "EEA": false, "AD": false, "BCR": false},
    'AG': {"label": 'Antigua and Barbuda', "EEA": false, "AD": false, "BCR": false},
    'AR': {"label": 'Argentina', "EEA": false, "AD": true, "BCR": false},
    'AM': {"label": 'Armenia', "EEA": false, "AD": false, "BCR": false},
    'AW': {"label": 'Aruba', "EEA": false, "AD": false, "BCR": false},
    'AU': {"label": 'Australia', "EEA": false, "AD": false, "BCR": false},
    'AT': {"label": 'Austria', "EEA": true, "AD": false, "BCR": true},
    'AZ': {"label": 'Azerbaijan', "EEA": false, "AD": false, "BCR": false},
    'BS': {"label": 'Bahamas', "EEA": false, "AD": false, "BCR": false},
    'BH': {"label": 'Bahrain', "EEA": false, "AD": false, "BCR": false},
    'BD': {"label": 'Bangladesh', "EEA": false, "AD": false, "BCR": false},
    'BB': {"label": 'Barbados', "EEA": false, "AD": false, "BCR": false},
    'BY': {"label": 'Belarus', "EEA": false, "AD": false, "BCR": false},
    'BE': {"label": 'Belgium', "EEA": true, "AD": false, "BCR": true},
    'BZ': {"label": 'Belize', "EEA": false, "AD": false, "BCR": false},
    'BJ': {"label": 'Benin', "EEA": false, "AD": false, "BCR": false},
    'BM': {"label": 'Bermuda', "EEA": false, "AD": false, "BCR": false},
    'BT': {"label": 'Bhutan', "EEA": false, "AD": false, "BCR": false},
    'BO': {"label": 'Bolivia', "EEA": false, "AD": false, "BCR": false},
    'BA': {"label": 'Bosnia and Herzegovina', "EEA": false, "AD": false, "BCR": false},
    'BW': {"label": 'Botswana', "EEA": false, "AD": false, "BCR": false},
    'BV': {"label": 'Bouvet Island', "EEA": false, "AD": false, "BCR": false},
    'BR': {"label": 'Brazil', "EEA": false, "AD": false, "BCR": false},
    'IO': {"label": 'British Indian Ocean Territory', "EEA": false, "AD": false, "BCR": false},
    'BN': {"label": 'Brunei Darussalam', "EEA": false, "AD": false, "BCR": false},
    'BG': {"label": 'Bulgaria', "EEA": true, "AD": false, "BCR": true},
    'BF': {"label": 'Burkina Faso', "EEA": false, "AD": false, "BCR": false},
    'BI': {"label": 'Burundi', "EEA": false, "AD": false, "BCR": false},
    'KH': {"label": 'Cambodia', "EEA": false, "AD": false, "BCR": false},
    'CM': {"label": 'Cameroon', "EEA": false, "AD": false, "BCR": false},
    'CA': {"label": 'Canada', "EEA": false, "AD": true, "BCR": false},
    'CV': {"label": 'Cape Verde', "EEA": false, "AD": false, "BCR": false},
    'KY': {"label": 'Cayman Islands', "EEA": false, "AD": false, "BCR": false},
    'CF': {"label": 'Central African Republic', "EEA": false, "AD": false, "BCR": false},
    'TD': {"label": 'Chad', "EEA": false, "AD": false, "BCR": false},
    'CL': {"label": 'Chile', "EEA": false, "AD": false, "BCR": false},
    'CN': {"label": 'China', "EEA": false, "AD": false, "BCR": false},
    'CX': {"label": 'Christmas Island', "EEA": false, "AD": false, "BCR": false},
    'CC': {"label": 'Cocos (Keeling) Islands', "EEA": false, "AD": false, "BCR": false},
    'CO': {"label": 'Colombia', "EEA": false, "AD": false, "BCR": false},
    'KM': {"label": 'Comoros', "EEA": false, "AD": false, "BCR": false},
    'CG': {"label": 'Congo', "EEA": false, "AD": false, "BCR": false},
    'CD': {"label": 'Congo, The Democratic Republic of the', "EEA": false, "AD": false, "BCR": false},
    'CK': {"label": 'Cook Islands', "EEA": false, "AD": false, "BCR": false},
    'CR': {"label": 'Costa Rica', "EEA": false, "AD": false, "BCR": false},
    'CI': {"label": 'Cote D\'Ivoire', "EEA": false, "AD": false, "BCR": false},
    'HR': {"label": 'Croatia', "EEA": true, "AD": false, "BCR": false},
    'CU': {"label": 'Cuba', "EEA": false, "AD": false, "BCR": false},
    'CY': {"label": 'Cyprus', "EEA": false, "AD": false, "BCR": true},
    'CZ': {"label": 'Czech Republic', "EEA": true, "AD": false, "BCR": true},
    'DK': {"label": 'Denmark', "EEA": true, "AD": false, "BCR": false},
    'DJ': {"label": 'Djibouti', "EEA": false, "AD": false, "BCR": false},
    'DM': {"label": 'Dominica', "EEA": false, "AD": false, "BCR": false},
    'DO': {"label": 'Dominican Republic', "EEA": false, "AD": false, "BCR": false},
    'EC': {"label": 'Ecuador', "EEA": false, "AD": false, "BCR": false},
    'EG': {"label": 'Egypt', "EEA": false, "AD": false, "BCR": false},
    'SV': {"label": 'El Salvador', "EEA": false, "AD": false, "BCR": false},
    'GQ': {"label": 'Equatorial Guinea', "EEA": false, "AD": false, "BCR": false},
    'ER': {"label": 'Eritrea', "EEA": false, "AD": false, "BCR": false},
    'EE': {"label": 'Estonia', "EEA": true, "AD": false, "BCR": true},
    'ET': {"label": 'Ethiopia', "EEA": false, "AD": false, "BCR": false},
    'FK': {"label": 'Falkland Islands (Malvinas)', "EEA": false, "AD": false, "BCR": false},
    'FO': {"label": 'Faroe Islands', "EEA": false, "AD": true, "BCR": false},
    'FJ': {"label": 'Fiji', "EEA": false, "AD": false, "BCR": false},
    'FI': {"label": 'Finland', "EEA": true, "AD": false, "BCR": false},
    'FR': {"label": 'France', "EEA": true, "AD": false, "BCR": true},
    'GF': {"label": 'French Guiana', "EEA": false, "AD": false, "BCR": false},
    'PF': {"label": 'French Polynesia', "EEA": false, "AD": false, "BCR": false},
    'TF': {"label": 'French Southern Territories', "EEA": false, "AD": false, "BCR": false},
    'GA': {"label": 'Gabon', "EEA": false, "AD": false, "BCR": false},
    'GM': {"label": 'Gambia', "EEA": false, "AD": false, "BCR": false},
    'GE': {"label": 'Georgia', "EEA": false, "AD": false, "BCR": false},
    'DE': {"label": 'Germany', "EEA": true, "AD": false, "BCR": true},
    'GH': {"label": 'Ghana', "EEA": false, "AD": false, "BCR": false},
    'GR': {"label": 'Greece', "EEA": true, "AD": false, "BCR": false},
    'GL': {"label": 'Greenland', "EEA": false, "AD": false, "BCR": false},
    'GD': {"label": 'Grenada', "EEA": false, "AD": false, "BCR": false},
    'GU': {"label": 'Guam', "EEA": false, "AD": false, "BCR": false},
    'GT': {"label": 'Guatemala', "EEA": false, "AD": false, "BCR": false},
    'GG': {"label": 'Guernsey', "EEA": false, "AD": true, "BCR": false},
    'GN': {"label": 'Guinea', "EEA": false, "AD": false, "BCR": false},
    'GW': {"label": 'Guinea-Bissau', "EEA": false, "AD": false, "BCR": false},
    'GY': {"label": 'Guyana', "EEA": false, "AD": false, "BCR": false},
    'HT': {"label": 'Haiti', "EEA": false, "AD": false, "BCR": false},
    'HM': {"label": 'Heard Island and Mcdonald Islands', "EEA": false, "AD": false, "BCR": false},
    'VA': {"label": 'Holy See (Vatican City State)', "EEA": false, "AD": false, "BCR": false},
    'HN': {"label": 'Honduras', "EEA": false, "AD": false, "BCR": false},
    'HK': {"label": 'Hong Kong', "EEA": false, "AD": false, "BCR": false},
    'HU': {"label": 'Hungary', "EEA": true, "AD": false, "BCR": false},
    'IS': {"label": 'Iceland', "EEA": true, "AD": false, "BCR": true},
    'IN': {"label": 'India', "EEA": false, "AD": false, "BCR": false},
    'ID': {"label": 'Indonesia', "EEA": false, "AD": false, "BCR": false},
    'IR': {"label": 'Iran, Islamic Republic Of', "EEA": false, "AD": false, "BCR": false},
    'IQ': {"label": 'Iraq', "EEA": false, "AD": false, "BCR": false},
    'IE': {"label": 'Ireland', "EEA": true, "AD": false, "BCR": true},
    'IM': {"label": 'Isle of Man', "EEA": false, "AD": true, "BCR": false},
    'IL': {"label": 'Israel', "EEA": false, "AD": true, "BCR": false},
    'IT': {"label": 'Italy', "EEA": true, "AD": false, "BCR": true},
    'JM': {"label": 'Jamaica', "EEA": false, "AD": false, "BCR": false},
    'JP': {"label": 'Japan', "EEA": false, "AD": false, "BCR": false},
    'JE': {"label": 'Jersey', "EEA": false, "AD": true, "BCR": false},
    'JO': {"label": 'Jordan', "EEA": false, "AD": false, "BCR": false},
    'KZ': {"label": 'Kazakhstan', "EEA": false, "AD": false, "BCR": false},
    'KE': {"label": 'Kenya', "EEA": false, "AD": false, "BCR": false},
    'KI': {"label": 'Kiribati', "EEA": false, "AD": false, "BCR": false},
    'KP': {"label": 'Korea, Democratic People\'S Republic of', "EEA": false, "AD": false, "BCR": false},
    'KR': {"label": 'Korea, Republic of', "EEA": false, "AD": false, "BCR": false},
    'KW': {"label": 'Kuwait', "EEA": false, "AD": false, "BCR": false},
    'KG': {"label": 'Kyrgyzstan', "EEA": false, "AD": false, "BCR": false},
    'LA': {"label": 'Lao People\'S Democratic Republic', "EEA": false, "AD": false, "BCR": false},
    'LV': {"label": 'Latvia', "EEA": true, "AD": false, "BCR": true},
    'LB': {"label": 'Lebanon', "EEA": false, "AD": false, "BCR": false},
    'LS': {"label": 'Lesotho', "EEA": false, "AD": false, "BCR": false},
    'LR': {"label": 'Liberia', "EEA": false, "AD": false, "BCR": false},
    'LY': {"label": 'Libyan Arab Jamahiriya', "EEA": false, "AD": false, "BCR": false},
    'LI': {"label": 'Liechtenstein', 'EEA': true, "AD": false, "BCR": true},
    'LT': {"label": 'Lithuania', "EEA": true, "AD": false, "BCR": false},
    'LU': {"label": 'Luxembourg', "EEA": true, "AD": false, "BCR": true},
    'MO': {"label": 'Macao', "EEA": false, "AD": false, "BCR": false},
    'MK': {"label": 'Macedonia, The Former Yugoslav Republic of', "EEA": false, "AD": false, "BCR": false},
    'MG': {"label": 'Madagascar', "EEA": false, "AD": false, "BCR": false},
    'MW': {"label": 'Malawi', "EEA": false, "AD": false, "BCR": false},
    'MY': {"label": 'Malaysia', "EEA": false, "AD": false, "BCR": false},
    'MV': {"label": 'Maldives', "EEA": false, "AD": false, "BCR": false},
    'ML': {"label": 'Mali', "EEA": false, "AD": false, "BCR": false},
    'MT': {"label": 'Malta', "EEA": false, "AD": false, "BCR": true},
    'MH': {"label": 'Marshall Islands', "EEA": false, "AD": false, "BCR": false},
    'MR': {"label": 'Mauritania', "EEA": false, "AD": false, "BCR": false},
    'MU': {"label": 'Mauritius', "EEA": false, "AD": false, "BCR": false},
    'YT': {"label": 'Mayotte', "EEA": false, "AD": false, "BCR": false},
    'MX': {"label": 'Mexico', "EEA": false, "AD": false, "BCR": false},
    'FM': {"label": 'Micronesia, Federated States of', "EEA": false, "AD": false, "BCR": false},
    'MD': {"label": 'Moldova, Republic of', "EEA": false, "AD": false, "BCR": false},
    'MC': {"label": 'Monaco', "EEA": false, "AD": false, "BCR": false},
    'MN': {"label": 'Mongolia', "EEA": false, "AD": false, "BCR": false},
    'MS': {"label": 'Montserrat', "EEA": false, "AD": false, "BCR": false},
    'MA': {"label": 'Morocco', "EEA": false, "AD": false, "BCR": false},
    'MZ': {"label": 'Mozambique', "EEA": false, "AD": false, "BCR": false},
    'MM': {"label": 'Myanmar', "EEA": false, "AD": false, "BCR": false},
    'NA': {"label": 'Namibia', "EEA": false, "AD": false, "BCR": false},
    'NR': {"label": 'Nauru', "EEA": false, "AD": false, "BCR": false},
    'NP': {"label": 'Nepal', "EEA": false, "AD": false, "BCR": false},
    'NL': {"label": 'Netherlands', "EEA": true, "AD": false, "BCR": true},
    'AN': {"label": 'Netherlands Antilles', "EEA": false, "AD": false, "BCR": false},
    'NC': {"label": 'New Caledonia', "EEA": false, "AD": false, "BCR": false},
    'NZ': {"label": 'New Zealand', "EEA": false, "AD": true, "BCR": false},
    'NI': {"label": 'Nicaragua', "EEA": false, "AD": false, "BCR": false},
    'NE': {"label": 'Niger', "EEA": false, "AD": false, "BCR": false},
    'NG': {"label": 'Nigeria', "EEA": false, "AD": false, "BCR": false},
    'NU': {"label": 'Niue', "EEA": false, "AD": false, "BCR": false},
    'NF': {"label": 'Norfolk Island', "EEA": false, "AD": false, "BCR": false},
    'MP': {"label": 'Northern Mariana Islands', "EEA": false, "AD": false, "BCR": false},
    'NO': {"label": 'Norway', 'EEA': true, "AD": false, "BCR": true},
    'OM': {"label": 'Oman', "EEA": false, "AD": false, "BCR": false},
    'PK': {"label": 'Pakistan', "EEA": false, "AD": false, "BCR": false},
    'PW': {"label": 'Palau', "EEA": false, "AD": false, "BCR": false},
    'PS': {"label": 'Palestinian Territory, Occupied', "EEA": false, "AD": false, "BCR": false},
    'PA': {"label": 'Panama', "EEA": false, "AD": false, "BCR": false},
    'PG': {"label": 'Papua New Guinea', "EEA": false, "AD": false, "BCR": false},
    'PY': {"label": 'Paraguay', "EEA": false, "AD": false, "BCR": false},
    'PE': {"label": 'Peru', "EEA": false, "AD": false, "BCR": false},
    'PH': {"label": 'Philippines', "EEA": false, "AD": false, "BCR": false},
    'PN': {"label": 'Pitcairn', "EEA": false, "AD": false, "BCR": false},
    'PL': {"label": 'Poland', "EEA": true, "AD": false, "BCR": false},
    'PT': {"label": 'Portugal', "EEA": true, "AD": false, "BCR": false},
    'PR': {"label": 'Puerto Rico', "EEA": false, "AD": false, "BCR": false},
    'QA': {"label": 'Qatar', "EEA": false, "AD": false, "BCR": false},
    'RO': {"label": 'Romania', "EEA": false, "AD": false, "BCR": false},
    'RU': {"label": 'Russian Federation', "EEA": false, "AD": false, "BCR": false},
    'RW': {"label": 'RWANDA', "EEA": false, "AD": false, "BCR": false},
    'SH': {"label": 'Saint Helena', "EEA": false, "AD": false, "BCR": false},
    'KN': {"label": 'Saint Kitts and Nevis', "EEA": false, "AD": false, "BCR": false},
    'LC': {"label": 'Saint Lucia', "EEA": false, "AD": false, "BCR": false},
    'PM': {"label": 'Saint Pierre and Miquelon', "EEA": false, "AD": false, "BCR": false},
    'VC': {"label": 'Saint Vincent and the Grenadines', "EEA": false, "AD": false, "BCR": false},
    'WS': {"label": 'Samoa', "EEA": false, "AD": false, "BCR": false},
    'SM': {"label": 'San Marino', "EEA": false, "AD": false, "BCR": false},
    'ST': {"label": 'Sao Tome and Principe', "EEA": false, "AD": false, "BCR": false},
    'SA': {"label": 'Saudi Arabia', "EEA": false, "AD": false, "BCR": false},
    'SN': {"label": 'Senegal', "EEA": false, "AD": false, "BCR": false},
    'CS': {"label": 'Serbia and Montenegro', "EEA": false, "AD": false, "BCR": false},
    'SC': {"label": 'Seychelles', "EEA": false, "AD": false, "BCR": false},
    'SL': {"label": 'Sierra Leone', "EEA": false, "AD": false, "BCR": false},
    'SG': {"label": 'Singapore', "EEA": false, "AD": false, "BCR": false},
    'SK': {"label": 'Slovakia', "EEA": false, "AD": false, "BCR": true},
    'SI': {"label": 'Slovenia', "EEA": false, "AD": false, "BCR": true},
    'SB': {"label": 'Solomon Islands', "EEA": false, "AD": false, "BCR": false},
    'SO': {"label": 'Somalia', "EEA": false, "AD": false, "BCR": false},
    'ZA': {"label": 'South Africa', "EEA": false, "AD": false, "BCR": false},
    'GS': {
        "label": 'South Georgia and the South Sandwich Islands',
                "EEA": false,
        "AD": false,
        "BCR": false
    },
    'ES': {"label": 'Spain', "EEA": true, "AD": false, "BCR": true},
    'LK': {"label": 'Sri Lanka', "EEA": false, "AD": false, "BCR": false},
    'SD': {"label": 'Sudan', "EEA": false, "AD": false, "BCR": false},
    'SR': {"label": 'Suriname', "EEA": false, "AD": false, "BCR": false},
    'SJ': {"label": 'Svalbard and Jan Mayen', "EEA": false, "AD": false, "BCR": false},
    'SZ': {"label": 'Swaziland', "EEA": false, "AD": false, "BCR": false},
    'SE': {"label": 'Sweden', "EEA": true, "AD": false, "BCR": false},
    'CH': {"label": 'Switzerland', 'EEA': false, "AD": true, "BCR": false},
    'SY': {"label": 'Syrian Arab Republic', "EEA": false, "AD": false, "BCR": false},
    'TW': {"label": 'Taiwan, Province of China', "EEA": false, "AD": false, "BCR": false},
    'TJ': {"label": 'Tajikistan', "EEA": false, "AD": false, "BCR": false},
    'TZ': {"label": 'Tanzania, United Republic of', "EEA": false, "AD": false, "BCR": false},
    'TH': {"label": 'Thailand', "EEA": false, "AD": false, "BCR": false},
    'TL': {"label": 'Timor-Leste', "EEA": false, "AD": false, "BCR": false},
    'TG': {"label": 'Togo', "EEA": false, "AD": false, "BCR": false},
    'TK': {"label": 'Tokelau', "EEA": false, "AD": false, "BCR": false},
    'TO': {"label": 'Tonga', "EEA": false, "AD": false, "BCR": false},
    'TT': {"label": 'Trinidad and Tobago', "EEA": false, "AD": false, "BCR": false},
    'TN': {"label": 'Tunisia', "EEA": false, "AD": false, "BCR": false},
    'TR': {"label": 'Turkey', "EEA": false, "AD": false, "BCR": false},
    'TM': {"label": 'Turkmenistan', "EEA": false, "AD": false, "BCR": false},
    'TC': {"label": 'Turks and Caicos Islands', "EEA": false, "AD": false, "BCR": false},
    'TV': {"label": 'Tuvalu', "EEA": false, "AD": false, "BCR": false},
    'UG': {"label": 'Uganda', "EEA": false, "AD": false, "BCR": false},
    'UA': {"label": 'Ukraine', "EEA": false, "AD": false, "BCR": false},
    'AE': {"label": 'United Arab Emirates', "EEA": false, "AD": false, "BCR": false},
    'GB': {"label": 'United Kingdom', "EEA": false, "AD": true, "BCR": false},
    'US': {"label": 'United States of America', "EEA": false, "AD": false, "BCR": false},
    'UM': {"label": 'United States Minor Outlying Islands', "EEA": false, "AD": false, "BCR": false},
    'UY': {"label": 'Uruguay', "EEA": false, "AD": true, "BCR": false},
    'UZ': {"label": 'Uzbekistan', "EEA": false, "AD": false, "BCR": false},
    'VU': {"label": 'Vanuatu', "EEA": false, "AD": false, "BCR": false},
    'VE': {"label": 'Venezuela', "EEA": false, "AD": false, "BCR": false},
    'VN': {"label": 'Viet Nam', "EEA": false, "AD": false, "BCR": false},
    'VG': {"label": 'Virgin Islands, British', "EEA": false, "AD": false, "BCR": false},
    'VI': {"label": 'Virgin Islands, U.S.', "EEA": false, "AD": false, "BCR": false},
    'WF': {"label": 'Wallis and Futuna', "EEA": false, "AD": false, "BCR": false},
    'EH': {"label": 'Western Sahara', "EEA": false, "AD": false, "BCR": false},
    'YE': {"label": 'Yemen', "EEA": false, "AD": false, "BCR": false},
    'ZM': {"label": 'Zambia', "EEA": false, "AD": false, "BCR": false},
    'ZW': {"label": 'Zimbabwe', "EEA": false, "AD": false, "BCR": false},
};



